var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSumma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4H3C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2H16C16 0.89543 15.1046 0 14 0H3C1.34315 0 0 1.34315 0 3V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4ZM2 16V6H16V8H9C8.44771 8 8 8.44771 8 9V13C8 13.5523 8.44771 14 9 14H16V16H2ZM12 11.5V10.5C12 10.2239 11.7761 10 11.5 10H10.5C10.2239 10 10 10.2239 10 10.5V11.5C10 11.7761 10.2239 12 10.5 12H11.5C11.7761 12 12 11.7761 12 11.5Z",
    fill: "#2B63C0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumma);
export default __webpack_public_path__ + "static/media/summa.ac188f9265dd478fa1fc606c43c2feda.svg";
export { ForwardRef as ReactComponent };